module.exports = __webpack_public_path__ + "static/media/banner_xLarge.f9d56207.png";